<template>
    <AppModal :has-borders="false"
              :fit-content="true"
              :class="widthClass">
        <template #trigger>
            <div class="text-center
                        cursor-pointer">
                <div class="relative mb-2">
                    <button class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl">
                        <IconCirclePlay class="text-3xl text-white" />
                    </button>
                    <img
                        class="object-cover rounded-md w-full desktop:w-auto"
                        :src="thumbnail"
                        alt=""
                    />
                </div>
                <p class="font-book text-xs desktop:text-sm underline">
                    {{ caption }}
                </p>
            </div>
        </template>
        <template #contents>
            <iframe
                title="Video Player"
                :src="`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&autoplay=1`"
                class="w-full desktop:w-262 h-96 desktop:h-150 mx-auto"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>
        </template>
    </AppModal>
</template>

<script>
    import AppModal from '~/Buyflow/components/AppModal'
    import IconCirclePlay from "@/atoms/icons/IconCirclePlay"

    export default {
        name: 'AppVideoPlayer',
        components: {
            AppModal,
            IconCirclePlay,
        },
        props: {
            videoId: {
                type: String,
                required: true,
            },
            thumbnail: {
                type: String,
                required: true,
            },
            thumbnailAlt: {
                type: String,
                required: true,
            },
            caption: {
                type: String,
                required: true,
            },
            widthClass: {
                type: String,
                default: 'w-full desktop:w-auto'
            }
        },
        mounted() {
            this.$emit('show')
        },
    }
</script>
